import React, { PureComponent } from 'react';
import {
    FormControl,
    Select,
    MenuItem,
} from '@material-ui/core'

const classes = {
    fullWidth: {
        width: '100%',
    },
    margin: {
        marginTop: 16,
        marginBottom: 8,
    },
}

class Dropdown extends PureComponent {
    render() {
        const {
            data: {
                value,
                name,
                menuItems,
            },
            handleChange,
            normal,
            margin
        } = this.props

        const items = menuItems.map((item, index) => {
            if (index === 0) {
                return <MenuItem key={index} value="">{item.label}</MenuItem>
            } else {
                return <MenuItem key={index} value={item.value}>{item.label}</MenuItem>
            }
        })

        return (
            <FormControl variant="outlined" style={margin ? { ...classes.fullWidth, ...classes.margin } : classes.fullWidth}>
                <Select
                    value={value}
                    onChange={handleChange}
                    displayEmpty
                    name={name}
                    autoWidth
                    margin={normal ? 'none' : 'dense'}
                >
                    {items}
                </Select>
            </FormControl>
        )
    }
}

export default Dropdown